import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getZipFile, toggleZip } from '../Actions/Library.action';

const LibraryDownload = () => {
  const dispatch = useDispatch();
  const { selected, zip, fileTemplateType, documents, photos } = useSelector(
    (state) => state.library
  );
  const download = () => {
    if (zip) dispatch(getZipFile(selected));
    else {
      let currentArr = [];
      if (fileTemplateType === 1) currentArr = [...documents.items?.value];
      if (fileTemplateType === 2) currentArr = [...photos.items?.value];
      let urls = currentArr
        .filter((item) => selected.includes(item.id))
        .map((item) => item.url);
      downloadQueue(urls);
    }
  };
  const downloadQueue = (queue) => {
    if (queue.length === 0) return;
    queue.forEach((file) => downloadFile(file));
  };
  const downloadFile = (url) => {
    return fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to download ${url}`);
        return res.blob();
      })
      .then((blob) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = url.substring(url.lastIndexOf('/') + 1);
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  };
  return (
    <div className="row align-right align-middle library__downloadContainer">
      <div className="library__switch">
        <label className="library__switch--label">
          <input
            type="checkbox"
            checked={zip}
            value={zip}
            onChange={() => dispatch(toggleZip())}
          />
          <span className="slider round"></span>
        </label>
        Make a zip-pack
      </div>
      <button
        className="button primary library__downloadBtn"
        disabled={selected.length === 0}
        onClick={download}
      >
        DOWNLOAD SELECTED
      </button>
    </div>
  );
};

export default LibraryDownload;
